import { ApiCaller, callApi, getUrlWithPathParams } from 'services/api'

import { DigitalPresence } from '../digitalPresences/types'
import { SignalAssessment } from './types'

const SIGNAL_ASSESSMENTS_ENDPOINT_PATH = '/signal-assessments/'

const apiPostSignalAssessment = (apiCaller: ApiCaller) => async (
  signalAssessment: SignalAssessment
): Promise<DigitalPresence> => {
  return await apiCaller<DigitalPresence>({
    data: signalAssessment,
    method: 'post',
    url: SIGNAL_ASSESSMENTS_ENDPOINT_PATH,
  })
}

export const apiPostSignalAssessmentAsAdmin = apiPostSignalAssessment(callApi)

const apiPutSignalAssessment = (apiCaller: ApiCaller) => (signalAssessment: SignalAssessment) => {
  return apiCaller<SignalAssessment>({
    method: 'put',
    url: getUrlWithPathParams(SIGNAL_ASSESSMENTS_ENDPOINT_PATH, signalAssessment.id),
    data: signalAssessment,
  })
}

export const apiPutSignalAssessmentAsAdmin = apiPutSignalAssessment(callApi)

const apiDeleteSignalAssessment = (apiCaller: ApiCaller) => async (
  signalAssessment: SignalAssessment
): Promise<void> => {
  return await apiCaller<void>({
    method: 'delete',
    url: getUrlWithPathParams(SIGNAL_ASSESSMENTS_ENDPOINT_PATH, signalAssessment.id),
  })
}

export const apiDeleteSignalAssessmentAsAdmin = apiDeleteSignalAssessment(callApi)
